// css =>
import "../../BaseStructure.css";
import Styled from "./Fotter.module.css";

function Fotter() {
    return (
        <div className="row" id={ Styled.FotterFrame }>
            <div className="col-12">
                <h3>Design & Powered By HERAM Studio</h3>
            </div>
        </div>
    );
}

export default Fotter;
